require('./detailsBar.scss');
const template = require('./detailsBar.html');

const deps = [];

module.exports = angular.module('bench.ui.detailsBar', deps).component('blDetailsBar', {
  template,
  controllerAs: 'vm',
  transclude: true,
  bindings: {
    hideActions: '=',
  },
});
